module.exports = __webpack_public_path__ + "static/prepgroup-logo-neg-a1dc198ec0135024abeda1aa4890d7df.png";